// extracted by mini-css-extract-plugin
export default {"contenedor-eleginos":"Eleginos-para-tu-proyecto_contenedor-eleginos__PUtDA","h3-titulo-eleginos":"Eleginos-para-tu-proyecto_h3-titulo-eleginos__nrOz7"};